import React, { Component } from 'react';

import { AxiosError } from 'axios';
import InfiniteSccroll from 'react-infinite-scroller';
import { Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';

import '../styles/containers/Parties.css';

import {
  generateKeyStr,
  getTableSort,
  isMobileResolution,
  openLink,
} from '../infrastructure/utils/common';
import { setFilterData, setFilterFlag } from '../actions/partiesActions';
import * as Service from '../services/PartiesService';
import Error from '../components/stateMessage/Error';
import InviteSearcher from '../components/parties/InviteSearcher';
import PartiesFilterForm from '../components/forms/PartiesFilterForm';
import PartiesList from '../components/parties/PartiesList/PartiesList';
import Spinner from '../components/utils/Spinner';
import TableSortingElem from '../infrastructure/TableSorting';
import TopPanel from '../components/utils/TopPanel';
import MobileTopPanelActions from '../components/utils/MobileTopPanelActions';
import MobileListSorter from '../components/utils/MobileListSorter';
import { mapFromPartyToPartyCSV } from '../infrastructure/utils/parties';

const initialState = {
  partiesLoaded: false,
  allParties: false,
  deactive: false,
  noData: false,
  parties: null,
  token: null,
  listKey: generateKeyStr(),
  activeSort: null,
  filterData: undefined,
  avaliableSort: [],
  filter: '',
  isError: false,
  concierge: false,
  firstLoad: true,
  usersLoaded: false,
  admins: null,
  isMobileFilterSelected: false,
  isMobileSortSelected: false,
  csvParties: [],
};

class Parties extends Component {
  term: string;

  constructor(props) {
    super(props);
    this.term = '';
    this.state = initialState;
  }

  async componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterData, activeFilter, activateFilter } = this.props;
    document.documentElement.style.overflow = 'hidden';
    if (activeFilter) {
      this.loadFirstParties(filterData);
      activateFilter(false);
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      await this.loadFirstParties();
    }
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'auto';
    this.setState({ deactive: true });
  }

  loadFirstParties = async filterData => {
    this.loadParties({
      token: 0,
      firstLoad: true,
      order: new TableSortingElem({
        name: 'partyLocation.address',
        isString: true,
        label: 'Location',
      }),
      filterData,
    });
  };

  loadMoreParties = async () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { token, activeSort, filterData } = this.state;
    this.loadParties({
      token,
      firstLoad: false,
      order: activeSort,
      filterData,
    });
  };

  loadCSVParties = async () =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject) => {
      try {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const { activeSort, filterData } = this.state;
        const data = await Service.getAllParties(
          activeSort,
          filterData,
          0,
          true
        );
        const csvParties = data.map(mapFromPartyToPartyCSV);
        this.setState({ csvParties }, () => {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          resolve();
        });
      } catch (e) {
        const error = e as AxiosError;
        alert(
          `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
        );
        console.log(e);
        reject();
      }
    });

  hideMessage = () => {
    this.setState({ isError: false });
  };

  handlePartyClick = (event, url) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filterData } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history, setFilter, activateFilter } = this.props;
    setFilter(filterData);
    activateFilter(true);
    openLink(event, url, history, !isMobileResolution());
  };

  findByInvite = async invite => {
    try {
      const party = await Service.getByCode(invite);
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      const { history } = this.props;
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      history.push(`party/${party.partyId}`);
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  changeSort = name => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { activeSort, avaliableSort, filterData } = this.state;
    const sort = getTableSort(name, activeSort, avaliableSort);
    this.setState({ activeSort: sort });
    this.loadParties({ token: 0, firstLoad: true, order: sort, filterData });
  };

  changeSortBySelect = (name, up) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { avaliableSort, filterData } = this.state;
    const sort = avaliableSort.find(s => s.name === name);
    if (!sort) return;
    sort.up = up;
    this.setState({ activeSort: sort });
    this.loadParties({ token: 0, firstLoad: true, order: sort, filterData });
  };

  getFilteredParties = async filterData => {
    this.setState({ filterData });
    this.loadFirstParties(filterData);
  };

  searchPartyByName = async val => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.term = val;
    if (val === '') {
      this.loadFirstParties(false);
      return;
    }
    if (val.length < 3) {
      return;
    }
    const data = await Service.searchByName(val);
    const res = data.map(party => ({
      label: party.partyName,
      value: party.partyId,
    }));
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (this.term === val) {
      this.setState({ parties: data, allParties: true });
    }
    // eslint-disable-next-line consistent-return
    return res.slice(0, 10);
  };

  removeFilter = () => {
    this.setState({ filterData: undefined });
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.loadFirstParties();
  };

  onPartySearched = id => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.push(`/party/${id}`);
  };

  loadParties = async ({ token, firstLoad, order, filterData }) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const data = await Service.getAllParties(order, filterData, token);
    if (data.length === 0) {
      if (firstLoad) {
        this.setState({ parties: [] });
      }
      this.setState({ allParties: true });
      return;
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { deactive } = this.state;
    if (!deactive) {
      if (firstLoad) {
        this.setState({
          parties: data,
          token: data.length,
          activeSort: order,
          listKey: generateKeyStr(),
          filterData,
          avaliableSort: [
            new TableSortingElem({
              name: 'partyLocation.address',
              isString: true,
              up: true,
              label: 'Location',
            }),
            new TableSortingElem({
              name: 'partyLocation.address',
              isString: true,
              up: false,
              label: 'Location',
            }),
            new TableSortingElem({
              name: 'startDate',
              up: true,
              label: 'Start Date',
            }),
            new TableSortingElem({
              name: 'startDate',
              up: false,
              label: 'Start Date',
            }),
            new TableSortingElem({
              name: 'partyName',
              isString: true,
              up: true,
              label: 'Party Name',
            }),
            new TableSortingElem({
              name: 'partyName',
              isString: true,
              up: false,
              label: 'Party Name',
            }),
            new TableSortingElem({
              name: 'createdAt',
              up: true,
              label: 'Created At',
            }),
            new TableSortingElem({
              name: 'createdAt',
              up: false,
              label: 'Created At',
            }),
          ],
          allParties: false,
          partiesLoaded: true,
        });
      } else {
        this.setState(state => ({
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          parties: state.parties?.concat(data),
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          token: state.token + 25,
        }));
      }
    }
  };

  applyQuickFilter = (filterData, sort) => {
    this.setState({ filterData }, () => {
      this.changeSort(sort);
    });
  };

  render() {
    const {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      partiesLoaded,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      parties,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      avaliableSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      filterData,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activeSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      listKey,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      allParties,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isError,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      errorMessage,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileFilterSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileSortSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      csvParties,
    } = this.state;

    if (!partiesLoaded) {
      return <Spinner />;
    }

    return (
      <>
        {isError && <Error text={errorMessage} />}
        <TopPanel>
          <h1
            className='col-md-6 col-sm-4 col-xs-3'
            style={{ marginTop: '0px', paddingLeft: '29px' }}
          >
            <span className='fas fa-glass-cheers' /> Parties
          </h1>
          <div className='pull-right parties-invite-code'>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              <InviteSearcher findByInvite={this.findByInvite} />
            }
          </div>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <MobileTopPanelActions
              isFilterSelected={isMobileFilterSelected}
              isSortSelected={isMobileSortSelected}
              onFilterClick={() =>
                this.setState({
                  isMobileFilterSelected: !isMobileFilterSelected,
                })
              }
              onSortClick={() =>
                this.setState({ isMobileSortSelected: !isMobileSortSelected })
              }
            />
          }
        </TopPanel>
        <div className='data-container'>
          <PartiesFilterForm
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            filterParties={this.getFilteredParties}
            filterData={filterData}
            clear={this.removeFilter}
            parties={parties}
            applyQuickFilter={this.applyQuickFilter}
            isMobileFilterSelected={isMobileFilterSelected}
            csvParties={csvParties}
            loadCSVParties={this.loadCSVParties}
          />
          <MobileListSorter
            isSortSelected={isMobileSortSelected}
            activeSort={activeSort}
            availableSort={avaliableSort}
            changeSortBySelect={this.changeSortBySelect}
          />
          <div className='clearfix filter-clearfix' />
          {parties.length > 0 ? (
            <div key={listKey} className='table-box tab-cont sm-height'>
              <InfiniteSccroll
                pageStart={0}
                loadMore={this.loadMoreParties}
                useWindow={false}
                hasMore={!allParties}
                loader={
                  <Glyphicon key={0} glyph='refresh' className='spinning' />
                }
              >
                <PartiesList
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  content={parties}
                  changeSort={this.changeSort}
                  activeSort={activeSort}
                  handleOnClick={this.handlePartyClick}
                />
              </InfiniteSccroll>
            </div>
          ) : (
            <h2>Parties list is empty</h2>
          )}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    filterData: state.parties.partyFilters,
    activeFilter: state.parties.activeFilter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFilter: data => dispatch(setFilterData(data)),
    activateFilter: data => dispatch(setFilterFlag(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Parties);
